import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ApiInterceptor } from './api-interceptor';
import { Provider } from '@angular/compiler/src/compiler_facade_interface';

export { ApiInterceptor };

export const HTTP_INTERCEPTOR_PROVIDERS: Provider = [
    {
        provide: HTTP_INTERCEPTORS,
        useClass: ApiInterceptor,
        multi: true
    }
];
